import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createEntryProceduresSchemas } from 'shared/db/validation/schema/entryProcedures';
import { Validator } from 'shared/db/validation/validator';
import {
    EntryProcedureRawRecord,
    EntryProcedureUpdateRawRecord,
} from 'shared/types/EntryProcedure';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { EntryProcedureDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createEntryProceduresSchemas();

const addValidator = createDBEntityValidator<EntryProcedureRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<EntryProcedureUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-entry-procedures'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createEntryProceduresInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const entryProceduresInputValidation: EntryProcedureDBValidation = {
    add: createEntryProceduresInputValidation(addValidator, validationStrategy),
    update: createEntryProceduresInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createEntryProceduresInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
